import React from 'react'

import { moneyMask, getCurrencySymbol } from './utils'
import style from './style.module.scss'

export const getAmountString = (value, currencyCodeOrId) => {
  const currencySymbol = getCurrencySymbol(currencyCodeOrId, currencyCodeOrId)
  const formated = moneyMask.resolve(String(value || 0))
  return `${formated}${currencySymbol ? ` ${currencySymbol}` : ''}`
}

export const Amount = ({ value, currencyCode, currencyId, className }) => {
  const currencySymbol = getCurrencySymbol(currencyCode, currencyId)
  const formated = moneyMask.resolve(String(value || 0))

  return (
    <span className={className || style.amount}>
      <span>{formated}</span>
      {currencySymbol && <span>{` ${currencySymbol}`}</span>}
    </span>
  )
}
